import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, Typography } from "@mui/material";
import {
  formatNumber,
  getReservationDetailsObject,
} from "utils/utils";
import {
  getBillingInvoiceDetails,
} from "redux/actions/BillingAction";
import CommonNoDataFound from "components/CommonNoDataFound/CommonNoDataFound";
import Loader from "components/loader/Loader";
import { tripDutySlipData } from "pages/operation/billing/billingFlow/billingInvoice/BillingInvoiceData";

const BillingDutySlipPDF = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const params = Object.fromEntries([...searchParams]);

  const queryParams = {
    cityId: params?.cityId || "",
    cityName: params?.cityName || "",
    companyId: params?.companyId || "",
    companyName: params?.companyName || "",
    tripId: params?.tripId || "",
    page: params?.page || "",
    pageRowSize: params?.pageRowSize || "",
    status: params?.status || "",
    fromDate: params?.fromDate === "undefined" ? "" : params?.fromDate ? params?.fromDate : "",
    toDate: params?.fromDate === "undefined" ? ""  : params?.toDate ? params?.toDate : "",
    startDate: params?.startDate || null,
    endDate: params?.endDate || null,
    magicToken: params?.magicToken || "",
    pageType: params?.pageType || ""
  }

  useEffect(() => {
    // dispatch(getBillingInvoiceDetails(queryParams?.tripId, "private"));
    dispatch(getBillingInvoiceDetails(queryParams?.magicToken, "public"));
  }, []);

  const tripDetails = useSelector((state) => state.getBillingInvoiceDetails?.bilingInvoiceDetails?.data);
  const tripDetailsLoader = useSelector((state) => state.getBillingInvoiceDetails?.loading);

  const tripTypeDetails = getReservationDetailsObject(tripDetails);

  const tripDutySlipDetails = tripDutySlipData(tripDetails, tripTypeDetails)
    //handle back 

  const commonGridRender = (arrayData, gridSize) => {
    return(arrayData?.map((details, index) => {

      if (details.isTable && details.tableData) {
        return (
          <div key={index} className="w-full ml-6">
            <h4 className="text-gray-600 text-[10px] font-[400]">
              {details.title}
            </h4>
            <div className="mt-2.5 mb-5">
              <table className="w-full border-collapse border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    {details.tableData.tableHeaders.map((header, headerIndex) => (
                      <th 
                        key={headerIndex} 
                        className="px-3 py-2 text-left border border-gray-300 text-gray-700 text-[10px] font-[400]"
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {details.tableData.tableData.map((guest, guestIndex) => (
                    <tr 
                      key={guestIndex} 
                      className={'bg-white'}
                    >
                      <td className="px-3 py-2 border border-gray-300 text-[10px] text-gray-700">
                        {guest.name}
                      </td>
                      <td className="px-3 py-2 border border-gray-300 text-[10px] text-gray-700">
                        {guest.phone}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        );        
      } else {
      return(<Grid container item xs={gridSize?.xs} sm={gridSize?.sm} md={gridSize?.md} key={index} className={`pb10 ${details?.title !== 'Reporting Addr' ? 'maxHeight30' : '' }`}>
        <Grid
          item
          xs={6}
          lg={6}
          xl={6}
          className="textleft"
          pl={3}
          sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}
          container
        >
          <Typography variant="body5" className="colorBlack op80">
            {details?.title}
          </Typography>
        </Grid>
        <Grid
          item
          xs={6}
          lg={6}
          xl={6}
          className="colorBlack textLeft"
          container
        >
          <Typography variant="body5" className="pr10">{details?.value}</Typography>
        </Grid>
      </Grid>)
      }
  }))
  }

  return (
    <Grid container className="br20" justifyContent={"center"}>
      {tripDetailsLoader ? <Loader /> :
      <Grid item md={11}>
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
        </Grid>
        <Grid className="invoiceBorder br20 mb20">
          <Grid container className="solidBorderBottomBlack pt10" item xs={12}>
            <Grid container item xs={6} md={6}>
            {commonGridRender(tripDutySlipDetails?.detailsArray1)}
            </Grid>

            <Grid
              container
              item
              xs={6}
              md={6}
              alignItems={"flex-start"}
              className="height100 flexColumn"
            >
              {commonGridRender(tripDutySlipDetails?.detailsArray2)}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt10" item xs={12}>
            <Grid container item xs={12}>
            {commonGridRender(tripDutySlipDetails?.detailsArray3, {xs:4, sm:4, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt10" item xs={12}>
            <Grid container item xs={12}>
              {commonGridRender(tripDutySlipDetails?.detailsArray4, {xs:4, sm:4, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt10" item xs={12}>
            <Grid container item xs={12} >
            {commonGridRender(tripDutySlipDetails?.detailsArray5, {xs:4, sm:4, md:4})}
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack" item xs={12}>
            <Grid container item md={12}>
              <Grid container item xs={4} className="pt10" flexDirection={'column'}>
                <Grid className="textleft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                  <Typography className="colorBlack pb10">
                  <Typography component={"span"} variant="body5" className="colorBlack op80">Toll Charges</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body5" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "tollCharges")?.addedCharge)) || 0}</Typography>
                  </Typography>
                </Grid>
                <Grid className="textleft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                  <Typography className="colorBlack pb10">
                  <Typography component={"span"} variant="body5" className="colorBlack op80">Parking Charges</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body5" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "parkingCharge")?.addedCharge)) || 0}</Typography>
                  </Typography>
                </Grid>
                <Grid className="textleft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                  <Typography className="colorBlack pb10">
                  <Typography component={"span"} variant="body5" className="colorBlack op80">Interstate Tax</Typography>
                     &nbsp;&nbsp;
                    <Typography component={"span"} variant="body5" className="colorBlack">{formatNumber(Number(tripDetails?.Payments[0]?.tripPricingDetails?.breakdown?.find((item) => item.chargeType === "interstateTax")?.addedCharge)) || 0}</Typography>
                  </Typography>
                </Grid>
              </Grid>
              <Grid container item xs={8} className="instructionBorder pt10">
                <Grid item className="textleft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                <Typography className="colorBlack pb10 alignStart">
                  <Typography variant="body5" className="colorBlack op80">Special Instruction</Typography>
                  <Typography  variant="body5" component={"p"} className="colorBlack pl20">{tripDetails?.note || ""}</Typography>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container className="solidBorderBottomBlack pt10" item xs={12}>
            <Grid container item xs={12} md={12}>
              {tripDutySlipDetails?.detailsArray6?.map((details, index) => (
                <Grid container item xs={3} key={index} className="pb10">
                  <Grid item xs={6} className="textleft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                    <Typography variant="body5" className="colorBlack op80">
                      {details?.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={6} className="colorBlack textLeft" sx={{ padding: { xs: "0px 0px 0px 10px", md: "0px 0px 0px 24px"}}}>
                    <Typography variant="body5">{details?.value}</Typography>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Grid>
          <Grid
            container
            justifyContent={"center"}
            className="pt10 pb10 solidBorderBottomBlack"
            item
            xs={12}
          >
            <Typography className="fw500 colorPrimary textCenter" variant="body6">
            {tripDetails?.vendorAddress  +" Website: "+ tripDetails?.vendorEmail || ""}
            </Typography>
          </Grid>
        <Grid container className="pt10 br20 m40">
          <Grid item xs={12} sm={5.5} className="height200 bgGrey justifyCenter">
            {tripDetails?.tripRouteImage?.url ? (
              <img src={tripDetails?.tripRouteImage?.url} alt="GoogleImage" className="width100 height100" />
            ) : (
              <CommonNoDataFound />
            )}
          </Grid>
          <Grid item xs={12} sm={5.5} className="plr20">
            <Box className="mb20">
              <Typography className="fw600 maxHeight30" variant="body3" component={"p"}>Guest Start Location</Typography>
              <Typography className="" variant="body5" component={"p"}>{tripDetails?.sourceAddress || ""}</Typography>
            </Box>
            <Box className="mb10">
              <Typography className="fw600" variant="body3" component={"p"}>Guest Drop Location</Typography>
              <Typography className="" variant="body5" component={"p"}>
                {tripTypeDetails?.tripAddress ||
                  tripTypeDetails?.destinationAddress ||
                  ""}
              </Typography>
            </Box>
            <Typography className="fw600 pb10" variant="body3" component={"p"}>
              Distance Covered:&nbsp;&nbsp;&nbsp;
              {tripDetails?.actualDistance || 0} km
            </Typography>
            <Grid container item xs={12} className="mfAuto" >
          <Grid item xs={12} sm={6} className="justifyCenter">
            <Typography className="textCenter colorPrimary fw600" variant="body3">
              Start Trip OTP Verified
              <br />
              {tripDetails?.TripOtp?.startOtp || ""}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={6} className="justifyCenter">
            <Typography className="textCenter colorPrimary fw600" variant="body3">
              End Trip OTP Verified
              <br />
              {tripDetails?.TripOtp?.endOtp || ""}
            </Typography>
          </Grid>
        </Grid>
          </Grid>
        </Grid>
      </Grid>

        {/* TODO: required an data from backend */}
        {tripDetails?.dutyTypeName === "Rental" && 
        tripDetails?.RoutingSummaries.length > 0 &&
        <Grid className="mt400">    
        <Typography variant="head6" className="fw600 pb30">
          Routing Summary Form Pick-Up To Drop
        </Typography>
        <Grid container className="solidBorderBottomBlack pb10 mt20">
          <Grid xs={12} sm={1} className="justifyCenter">
            <Typography variant="head6" className="textCenter">Sr. No.</Typography>
          </Grid>
          <Grid xs={12} sm={11}>
            <Typography variant="head6">Location</Typography>
          </Grid>
        </Grid>
        {tripDetails?.RoutingSummaries &&
          tripDetails?.RoutingSummaries?.map((routingData, index) => (
            <Grid container className="ptb20 dashedBorderBottom">
              <Grid xs={12} sm={1} className="justifyCenter">
                <Typography variant="body3" className="colorGrey textCenter">{index + 1}</Typography>
              </Grid>
              <Grid xs={12} sm={11}>  
                <Typography variant="body3" className="colorGrey">{routingData?.address}</Typography>
              </Grid>
            </Grid>
          ))}
        </Grid>
        }
      </Grid>
        }
    </Grid>
  );
};

export default BillingDutySlipPDF;
